import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import { LocaleContext } from '@/marketing/i18n/LocaleContext';
import { liveLocale, DEFAULT_LOCALE } from '@/marketing/i18n/locales';
import { instanceFor } from '@/marketing/i18n/instances';

/**
 * Re-provides the marketing DS locale context (LocaleContext + a per-locale
 * i18next instance) so marketing components — Footer, PricingPlanCard — can be
 * reused inside the signup funnel, which runs OUTSIDE the marketing
 * `LocaleLayout`. Reads the active `:lang` route param; unknown/funnel-only
 * codes fall back to the default live locale.
 */
export default function MarketingLocale({ children }: { children: ReactNode }) {
  const { lang } = useParams<{ lang?: string }>();
  const def = liveLocale(lang) ?? liveLocale(DEFAULT_LOCALE)!;
  return (
    <LocaleContext.Provider value={def}>
      <I18nextProvider i18n={instanceFor(def.code)}>{children}</I18nextProvider>
    </LocaleContext.Provider>
  );
}
